import { useOnboardingStore } from '../../stores/onboardingStore'

export default function TopEdgeProgress() {
  const current = useOnboardingStore((s) => s.currentStep)
  const stepsLength = useOnboardingStore((s) => s.steps.length)
  const liteMode = useOnboardingStore((s) => s.liteMode)
  const total = liteMode ? 10 : stepsLength
  const pct = Math.max(0, Math.min(100, (current / total) * 100))

  return (
    <div className="top-edge-progress" aria-hidden="true">
      <div
        className="tep-fill"
        style={{ width: `${pct}%` }}
      />
    </div>
  )
}
